import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import {BaseListComponent} from '../../SharedModule/BaseListComponent/base-list.component';
import {SnackService} from '../../services/snack.service';
import {DialogService} from '../../services/dialog.service';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import {CustomerContactPersonService} from '../../services/customer-contact-person.service';
import {Pagination} from '../../model/Helpers/Pagination';
import {Filter} from '../../model/Helpers/Filter';
import {CustomerContactPerson} from '../../model/Entities/CustomerContactPerson';
import {CustomerContactPersonDialogComponent} from '../CustomerContactPersonDialogComponent/customer-contact-person.dialog.component';
import {SortInfo} from '../../model/Helpers/SortInfo';
import {CustomerContactPersonDeleteConfirmDialogComponent} from '../CustomerContactPersonDeleteConfirmDialogComponent/customer-contact-person-delete-confirm.dialog.component';

@Component({
    selector: 'customer-contact-persons-list',
    templateUrl: './customer-contact-persons-list.component.html',
    styleUrls: ['./customer-contact-persons-list.component.scss']
})
export class CustomerContactPersonsListComponent extends BaseListComponent implements OnChanges {

    @Input() customerId;

    dataLoaded = false;
    contactPersons: CustomerContactPerson[] = [];

    constructor(private customerContactPersonService: CustomerContactPersonService,
                private dialogService: DialogService,
                private snackService: SnackService) {
        super();

        // this.dataSource = new CustomersDataSource(this.customerService);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.reloadData();
    }

    reloadData(): void {
        if (!this.customerId) {
            return;
        }

        this.dataLoaded = false;
        this.customerContactPersonService.getPaginatedList(new Pagination(999, 0), new SortInfo('surname'), [
            new Filter('customerId', this.customerId)
        ]).subscribe((data) => {
            this.dataLoaded = true;
            this.contactPersons = data.results;
        });
    }

    showContactPersonDialog(person: CustomerContactPerson): void {
        this.dialogService.showDialog(CustomerContactPersonDialogComponent, {
            'person': person
        }, 600).afterClosed().subscribe((person: CustomerContactPerson) => {
            if (person && person.id) {
                this.customerContactPersonService.update(person.id, person).subscribe((resultPerson: CustomerContactPerson) => {
                    this.reloadData();
                    this.snackService.showSuccess(`Kontaktní osoba ${resultPerson.name} ${resultPerson.surname} byla upravena`);
                });
            } else if (person) {
                person.customerId = this.customerId;
                this.customerContactPersonService.save(person).subscribe((resultPerson: CustomerContactPerson) => {
                    this.reloadData();
                    this.snackService.showSuccess(`Kontaktní osoba ${resultPerson.name} ${resultPerson.surname} byla vytvořena`);
                });
            }
        });
    }

    showContactPersonDeleteDialog(person: CustomerContactPerson): void {
        this.dialogService.showDialog(CustomerContactPersonDeleteConfirmDialogComponent, {
            'person': person
        }).afterClosed().subscribe(() => {
            this.customerContactPersonService.delete(person.id).subscribe(() => {
                this.snackService.showSuccess(`Kontaktní osoba ${person.name} ${person.surname} byla smazána`);
                this.reloadData();
            });
        });
    }

    private emailPerson(person: CustomerContactPerson) {
        window.location.href = 'mailto:' + person.email;
    }

}




// WEBPACK FOOTER //
// /app/src/CustomersModule/CustomerContactPersonsListComponent/customer-contact-persons-list.component.ts